import React, { useEffect, useState } from "react";
import { resetSession } from "../../../../redux/auth";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  AddSchedulingCommentAction,
  getSchedulingCommentListAction,
  resetSchedulingCommentListing,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../../redux/scheduling";
import {
  CircularAvatar,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableHeader,
} from "../../../commons";
import { noResultIcon } from "../../../../assets/images";
import { toast } from "react-hot-toast";
import {
  formatDate,
  formateDateTime,
  formateDateWithTime,
} from "../../../../utils/commonFunctions";
import moment from "moment";
type AppProps = {
  showSchedulingEstimateData: any;
  token: string | null;
  dispatchGetCommentList: (data: any) => void;
  dispatchResetSession: () => void;
  dispatchAddComment: (data: any) => void;
  statusCode: number | null;
  success: number | null;
  message: string | null;
  fetching: boolean;
  error: null | string;
  commentList: any[];
  dispatchResetCommentList: () => void;
  dispatchResetUserViewSuccess: () => void;
  dispatchResetUserViewError: () => void;
  dispatchResetUserViewMessage: () => void;
  dispatchResetUserViewStatusCode: () => void;
  handleupdateAction?: (data: string, action: string) => void;
  handleLable?: string | undefined;
  getAction?: string;
  history?: any;
};
const CommentTab = ({
  showSchedulingEstimateData,
  dispatchGetCommentList,
  dispatchAddComment,
  dispatchResetSession,
  dispatchResetUserViewSuccess,
  dispatchResetUserViewError,
  dispatchResetUserViewMessage,
  dispatchResetUserViewStatusCode,
  token,
  statusCode,
  success,
  message,
  error,
  fetching,
  commentList,
  dispatchResetCommentList,
  handleupdateAction,
  handleLable,
  getAction,
  history,
}: AppProps) => {
  const [requestId, setRequestId] = useState<string>("");
  const [commentInput, setCommentInput] = useState<string>("");

  useEffect(() => {
    dispatchResetCommentList();
    dispatchResetUserViewError();
    dispatchResetUserViewMessage();
    dispatchResetUserViewStatusCode();
    dispatchResetUserViewSuccess();
    toast.remove()
  }, []);
  useEffect(() => {
    if (!showSchedulingEstimateData?.req_id) {
      setRequestId(showSchedulingEstimateData?._id);
    } else {
      setRequestId(showSchedulingEstimateData?.req_id);
    }
  }, []);

  useEffect(() => {
    if (token && requestId) {
      let finalData = {
        token,
        requestId,
      };
      dispatchGetCommentList(finalData);
    }
  }, [requestId]);

  const handleCommentInputChange = (e: any) => {
    setCommentInput(e.target.value);
  };
  const handleSubmitComment = (e: any) => {
    // setRequestId(showSchedulingEstimateData?.req_id);
    let finalData: any = {
      request_id: requestId,
      comment: commentInput,
      token,
    };
    dispatchAddComment(finalData);
    setCommentInput("");
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserViewError();
            }}
          />
        );
      }
    }

    if (
      success === 1 &&
      message == "Scheduling  comment has been added successfully!"
    ) {
      let finalData = {
        token,
        requestId,
      };
      dispatchGetCommentList(finalData);
      dispatchResetUserViewSuccess();
      dispatchResetUserViewMessage();
      toast.success("Scheduling  comment has been added successfully!", {
        duration: 2000,
      });
    }
    return false;
  };

  let tableHeader = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "Hours",
      value: "hours",
    },
  ];
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ width: "40%" }}>
        <h4 className="mt-3" style={{ fontSize: "14px", color: "#262a44" }}>
          ALL COMMENTS
        </h4>
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <input
              style={{
                border: "2px solid #bfcbe1",
                borderRadius: "5px",
                padding: "10px",
                fontSize: "14px",
              }}
              type="text"
              name="text"
              value={commentInput}
              placeholder="Add a comment..."
              onChange={(e) => handleCommentInputChange(e)}
              onKeyPress={(e: any) =>
                e.key === "Enter" ? handleSubmitComment(e) : null
              }
            />{" "}
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                style={{ width: "fit-content" }}
                className="btn btn-primary"
                onClick={(e: any) => {
                  handleSubmitComment(e);
                }}
                disabled={commentInput?.trim()?.length === 0}
              >
                {"Post"}
              </button>
            </div>
          </div>
          {commentList?.length > 0 ? (
            <div className="row">
              <div className="col-md-12">
                {commentList.map((comment) => {
                  return (
                    <div style={{ display: "flex", margin: "20px 0" }}>
                      <CircularAvatar
                        name={`${comment?.first_name} ${comment?.last_name}`}
                        image={
                          comment?.profile_pic && comment?.profile_pic?.file_url
                        }
                      />

                      <div
                        style={{
                          display: "flex",
                          gap: "6px",
                          flexDirection: "column",
                          marginLeft: "10px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            color: "#6e7491",
                          }}
                        >
                          <span>
                            {comment?.first_name} {comment?.last_name}
                          </span>
                          <span>{formateDateTime(comment?.created_at)}</span>
                        </div>
                        <span style={{ color: "#262a44", fontSize: "14px" }}>
                          {comment?.comment}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                paddingBottom: "6rem",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={noResultIcon} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span> There are no comments here. </span>
                <span>If your estimate has any updates,</span>
                <span>then your manager will add comments here.</span>
              </div>
            </div>
          )}
        </>

        {handleErrorModal()}
        {fetching && <Loader />}
      </div>
      {getAction === "reject" && (
        <div
          className="jobsType"
          style={{ width: "50%", maxHeight: "400px", overflowY: "scroll" }}
        >
          <h4 className="mt-3" style={{ fontSize: "14px", color: "#262a44" }}>
            Scheduling Hours
          </h4>
          <table className="table table-bordered thead-light">
            <thead className="text-start sticky-table-header-without-zindex">
              <TableHeader tableHeader={tableHeader} />
            </thead>
            <tbody>
              {showSchedulingEstimateData?.estimate_data?.length > 0 &&
                showSchedulingEstimateData?.estimate_data?.map((el: any) => {
                  return (
                    <tr className="text-left">
                      {tableHeader?.length > 0 &&
                        tableHeader?.map((header: any) => {
                          if (header?.value == "date") {
                            return (
                              <td className="text-left">
                                {moment(el?.date).format("dddd, DD-MM-YYYY")}
                              </td>
                            );
                          } else if (header?.value == "hours") {
                            return <td className="text-left">{el?.hours}</td>;
                          }
                        })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  message: state.scheduling.message,
  fetching: state.scheduling.commentFetching,
  commentList: state.scheduling.commentList,
  totalCount: state.timeSheet.unfilledTimesheetCount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetCommentList: (data: any) =>
    dispatch(getSchedulingCommentListAction(data)),
  dispatchAddComment: (data: any) => dispatch(AddSchedulingCommentAction(data)),
  dispatchResetCommentList: () => dispatch(resetSchedulingCommentListing()),
  dispatchResetUserViewSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetUserViewError: () => dispatch(resetSchedulingError()),
  dispatchResetUserViewMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetUserViewStatusCode: () => dispatch(resetSchedulingStatusCode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentTab);
